<template>
    <div>
        <div class="color-container">
            <div :class="{'color-display': true, 'select-active': selectedColor !== null }">
                <div v-for="color in colors"
                     :class="{'color-option hoverable': true, 'selected': selectedColor === color}"
                     @click="selectedColor === color ? selectColor(null) : selectColor(color)">
                    <span class="color-name">{{ color.name }}</span>
                    <img :src="color.img">
                </div>
            </div>
            <div v-if="selectedColor !== null" class="color-description">
                <h4>{{ selectedColor.full_name }}</h4>
                <span v-html="selectedColor.fabric.description"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"
    export default {
        name: 'ColorDisplay',
        computed: mapGetters(['colors', 'selectedColor']),
        methods: {
            selectColor(color) {
                this.$store.dispatch(types.SET_COLOR, color)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ColorDisplay.vue?16998aaf